export const GAME_STATUS = {
  NEW: "new",
  OVER: "over",
  PLAYING: "playing",
};